<template>
  <div class="content">
    <p class="title">党员概括</p>
    <el-form
      label-position="right"
      label-width="120px"
      :model="formData"
      :rules="rules"
      ref="refForm"
    >
      <el-form-item label="正式党员" prop="full_party_member">
        <el-input
          type="number"
          min="0"
          class="numInput"
          v-model="formData.full_party_member"
        ></el-input>
      </el-form-item>
      <el-form-item label="预备党员" prop="probationary_party_member">
        <el-input
          type="number"
          min="0"
          class="numInput"
          v-model="formData.probationary_party_member"
        ></el-input>
      </el-form-item>
      <!-- <p class="title">主题学习概括</p>
      <el-form-item label="举办活动次数" prop="activity_nums">
        <el-input
          type="number"
          min="0"
          class="numInput"
          v-model="formData.activity_nums"
        ></el-input>
      </el-form-item>
      <el-form-item label="参与活动人数" prop="take_park_in_nums">
        <el-input
          type="number"
          min="0"
          class="numInput"
          v-model="formData.take_park_in_nums"
        ></el-input>
      </el-form-item> -->
    </el-form>
    <!-- 党龄分布 -->
    <p class="title">党龄分布</p>
    <div class="formBox">
      <el-form
        v-for="(partyAgeItem, partyAgeIndex) in formData.party_age_distribution"
        :ref="`partyAgeForm${partyAgeIndex}`"
        :key="'partyAge' + partyAgeIndex"
        :model="partyAgeItem"
        :rules="rules"
        :inline="true"
      >
        <el-form-item
          label-width="120px"
          label="年龄段："
          prop="age_group"
          class="err_position"
        >
          <el-input
            disabled
            v-model="partyAgeItem.age_group"
            style="width: 207px; float: left"
            placeholder="请输入内容"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label-width="120px"
          label="数量"
          prop="nums"
          class="err_position"
        >
          <el-input
            type="number"
            min="0"
            class="numInput"
            v-model="partyAgeItem.nums"
            style="width: 207px; float: left"
            placeholder="请输入数量"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <!-- 党费缴纳情况 -->
    <p class="title">党费缴纳情况</p>
    <div class="formBox">
      <el-form
        v-for="(
          partyFeeItem, partyFeeIndex
        ) in formData.party_fee_payment_status"
        :ref="`partyFeeForm${partyFeeIndex}`"
        :key="'partyFee' + partyFeeIndex"
        :model="partyFeeItem"
        :rules="rules"
        :inline="true"
      >
        <el-form-item label-width="120px" label="时间：" prop="time">
          <el-input
            disabled
            v-model="partyFeeItem.year_month"
            style="width: 207px; float: left"
            placeholder="请输入内容"
          >
            <template slot="append">月</template></el-input
          >
        </el-form-item>
        <el-form-item
          label-width="120px"
          label="已缴纳："
          prop="park_settlements"
        >
          <el-input
            type="number"
            min="0"
            class="numInput"
            v-model="partyFeeItem.park_settlements"
            style="width: 207px; float: left"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item
          label-width="120px"
          label="未缴纳："
          prop="park_vacant_area"
        >
          <el-input
            type="number"
            min="0"
            class="numInput"
            v-model="partyFeeItem.park_vacant_area"
            style="width: 207px; float: left"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <!-- 园区党建活动参与人员活跃统计 -->
    <!-- <p class="title">园区党建活动参与人员活跃统计</p>
    <div class="formBox">
      <el-form
        v-for="(
          partyActiveItem, partyActiveIndex
        ) in formData.party_active_statistics"
        :ref="`partyActiveForm${partyActiveIndex}`"
        :key="'partyActive' + partyActiveIndex"
        :model="partyActiveItem"
        :rules="rules"
        :inline="true"
      >
        <el-form-item label-width="120px" label="时间：" prop="time">
          <el-input
            disabled
            v-model="partyActiveItem.year_month"
            style="width: 207px; float: left"
            placeholder="请输入内容"
          >
            <template slot="append">月</template></el-input
          >
        </el-form-item>
        <el-form-item
          label-width="120px"
          label="人数："
          prop="park_settlements"
        >
          <el-input
            type="number"
            min="0"
            class="numInput"
            v-model="partyActiveItem.park_settlements"
            style="width: 207px; float: left"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
      </el-form>
    </div> -->

    <el-form>
      <el-form-item>
        <el-button type="primary" @click="infoSubmit()">保存</el-button>
        <el-button @click="getInfo()">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { wcYqdjConfigDetail, wcYqdjConfigEdit } from "@/api/wuchang";
export default {
  components: {},
  computed: {
    ...mapGetters(["imageOss"]),
  },
  data() {
    return {
      loading: false, //是显示加载
      formData: {
        full_party_member: "21",
        probationary_party_member: "2",
        activity_nums: "1",
        take_park_in_nums: "5",
        party_age_distribution: [
          {
            age_group: "1-5年",
            nums: "",
          },
          {
            age_group: "6-10年",
            nums: "",
          },
          {
            age_group: "10-15年",
            nums: "",
          },
          {
            age_group: "15-20年",
            nums: "",
          },
          {
            age_group: "21-25年",
            nums: "",
          },
          {
            age_group: "26-30年",
            nums: "",
          },
          {
            age_group: "31-35年",
            nums: "",
          },
        ],
        party_fee_payment_status: [
          {
            year_month: "1",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "2",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "3",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "4",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "5",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "6",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "7",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "8",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "9",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "10",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "11",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "12",
            park_settlements: "",
            park_vacant_area: "",
          },
        ],
        party_active_statistics: [
          {
            year_month: "1",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "2",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "3",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "4",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "5",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "6",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "7",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "8",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "9",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "10",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "11",
            park_settlements: "",
            park_vacant_area: "",
          },
          {
            year_month: "12",
            park_settlements: "",
            park_vacant_area: "",
          },
        ],
      },
      rules: {
        year_month: [
          { required: true, message: "请输入月份", trigger: "blur" },
        ],
        nums: [{ required: true, message: "请输入数量", trigger: "blur" }],
        park_settlements: [
          {
            required: true,
            message: "请输入数量",
            trigger: "blur",
          },
        ],
        park_vacant_area: [
          {
            required: true,
            message: "请输入面积",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "请输入类型名称",
            trigger: "blur",
          },
        ],
        proportion: [
          {
            required: true,
            message: "请输入数量",
            trigger: "blur",
          },
        ],
        introduced_projects: [
          { required: true, message: "请输入引进项目数量", trigger: "blur" },
        ],
        completion_rate: [
          { required: true, message: "请输入招商完成率", trigger: "blur" },
        ],
        settlement_rate: [
          { required: true, message: "请输招商入驻率", trigger: "blur" },
        ],
        converted: [
          { required: true, message: "请输入已转化", trigger: "blur" },
        ],
        to_be_converted: [
          { required: true, message: "请输入待转化", trigger: "blur" },
        ],
        year: [{ required: true, message: "请输入年份", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    convertedIup(e) {
      this.formData.to_be_converted = 100 - e.target.value;
    },
    beConvertedIup(e) {
      this.formData.converted = 100 - e.target.value;
    },
    // 获取基础信息
    getInfo() {
      wcYqdjConfigDetail().then((res) => {
        if (res.data.party_summary) {
          this.formData.full_party_member = JSON.parse(
            res.data.party_summary
          ).full_party_member;
          this.formData.probationary_party_member = JSON.parse(
            res.data.party_summary
          ).probationary_party_member;
        }


        // if (res.data.party_theme_learning) {
        //   this.formData.activity_nums = JSON.parse(
        //     res.data.party_theme_learning
        //   ).activity_nums;
        //   this.formData.take_park_in_nums = JSON.parse(
        //     res.data.party_theme_learning
        //   ).take_park_in_nums;
        // }
        if (res.data.party_age_distribution) {
          this.formData.party_age_distribution = JSON.parse(
            res.data.party_age_distribution
          );
        }
        if (res.data.party_fee_payment_status) {
          this.formData.party_fee_payment_status = JSON.parse(
            res.data.party_fee_payment_status
          );
        }
        // if (res.data.party_active_statistics) {
        //   this.formData.party_active_statistics = JSON.parse(
        //     res.data.party_active_statistics
        //   );
        // }
      });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.activityFormVisible = false;
    },
    infoSubmit() {
      var that = this;
      //用Promise.all进行全部form表单的验证
      Promise.all([
        //非数组部分的表单
        this.validateForm("refForm"),
        // 数组部分的表单，用map返回验证函数的调用

        // 党龄分布
        ...this.formData.party_age_distribution.map((item, index) =>
          this.validateForm(`partyAgeForm${index}`)
        ),
        // 党费缴纳情况
        ...this.formData.party_fee_payment_status.map((item, index) =>
          this.validateForm(`partyFeeForm${index}`)
        ),
        // 园区党建活动参与人员活跃统计
        // ...this.formData.party_active_statistics.map((item, index) =>
        //   this.validateForm(`partyActiveForm${index}`)
        // ),
        // this.$nextTick(() => {
        //   that.elFormErrorScrollIntoView();
        // }),
      ]).then((res) => {
        let party_summary = {
          full_party_member: this.formData.full_party_member,
          probationary_party_member: this.formData.probationary_party_member,
        };
        let party_theme_learning = {
          activity_nums: this.formData.activity_nums,
          take_park_in_nums: this.formData.take_park_in_nums,
        };
        let data = {
          party_summary: JSON.stringify(party_summary),
          // party_theme_learning: JSON.stringify(party_theme_learning),
          party_age_distribution: JSON.stringify(
            this.formData.party_age_distribution
          ),
          party_fee_payment_status: JSON.stringify(
            this.formData.party_fee_payment_status
          ),
          // party_active_statistics: JSON.stringify(
          //   this.formData.party_active_statistics
          // ),
        };
        wcYqdjConfigEdit(data).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            that.getInfo();
          }
        });
        if (res) {
          // 全部表单验证通过
        }
      });
    },
    validateForm(refs) {
      //获取到form表单的dom，如果是对象直接拿到，如果是数组，就拿第一个
      //elementui对循环的form包装成了数组
      let valiForm = this.$refs?.[refs].validate
        ? this.$refs?.[refs]
        : this.$refs?.[refs][0];
      return new Promise((resolve, reject) => {
        //在Promise里进行验证，如果通过就resolve()
        valiForm.validate((res) => {
          if (res) resolve();
          else reject();
        });
      });
    },
    // 园区税收统计
    addParkTax() {
      this.formData.park_tax_statistics.push({
        year: "",
        nums: "",
      });
    },
    // 删除园区税收统计
    delParkTax(index) {
      this.formData.park_tax_statistics.splice(index, 1);
    },
    // 添加园区营收统计
    addParkRevenue() {
      this.formData.park_revenue_statistics.push({
        type: "",
        proportion: "",
      });
    },
    // 删除园区营收统计
    delParkRevenue(index) {
      this.formData.park_revenue_statistics.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 20px;
}
.info {
  width: 100%;
  height: 100%;
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  padding: 20px;
}

.box-card {
  width: 300px;
  height: 100px;
  display: inline-block;
  margin: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  text-align: center;
  line-height: 100px;
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
.title {
  font-size: 16px;
  font-weight: 600;
}
.formBox {
  width: 100%;
  max-height: 300px;
  overflow: auto;
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
